var _style, _circle, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 9.5,
    className: "st0",
    width: 36,
    height: 36
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14,15.5c0-0.8,0.7-1.5,1.5-1.5h3v-3h-3C13,11,11,13,11,15.5v3h3V15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14,39.5v-3h-3v3c0,2.5,2,4.5,4.5,4.5h3v-3h-3C14.7,41,14,40.3,14,39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.5,11h-3v3h3c0.8,0,1.5,0.7,1.5,1.5v3h3v-3C44,13,42,11,39.5,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41,39.5c0,0.8-0.7,1.5-1.5,1.5h-3v3h3c2.5,0,4.5-2,4.5-4.5v-3h-3V39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,31.8v-8.6c0-1.1-0.6-2.1-1.5-2.6L29,16.3c-0.5-0.3-1-0.4-1.5-0.4s-1,0.1-1.5,0.4l-7.5,4.3 c-0.9,0.5-1.5,1.5-1.5,2.6v8.6c0,1.1,0.6,2.1,1.5,2.6l7.5,4.3c0.5,0.3,1,0.4,1.5,0.4s1-0.1,1.5-0.4l7.5-4.3 C37.4,33.9,38,32.9,38,31.8z M26,35.3l-6-3.5v-6.9l6,3.5V35.3z M27.5,25.8l-5.9-3.5l5.9-3.4l5.9,3.4L27.5,25.8z M35,31.8l-6,3.5 v-6.9l6-3.5V31.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpace);
export default __webpack_public_path__ + "static/media/space.a2e567d1437a915e011c78e9abc2f914.svg";
export { ForwardRef as ReactComponent };